export default {
  consult: {},
  quota: {},
  documentsConsulted: [],
};
